import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-checkin-icon',
  templateUrl: './checkin-icon.component.html',
  styles: []
})
export class CheckinIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
